export default "__VITE_ASSET__TRi14K6X__"